import React from "react";
import styled from "styled-components";
import { FaInfo } from "react-icons/fa";
const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  font-size: 0.7em;
`;
const InfoIcon = styled(FaInfo)`
  margin-right: 2px;
  position: absolute;
  left: 3px;
  font-size: 1.5em;
`;
const Content = styled.div`
  display: flex;
  height: 100%;
  font-size: 1.2em;
  align-items: center;
`;

export default function Opta6({ item }) {
  return (
    <Main>
      <Title>
        <InfoIcon />
        Corner
      </Title>
      <Content></Content>
    </Main>
  );
}
